import type { JSX } from 'react';
import { DateTime } from '@ksyos/date-time';
import { Badge, Col, FormGroup, FormParagraph, Row } from '@ksyos/design-system';
import { getBadge, getPreviousBariPreCaroInactivityPoliReportActivities } from '@common/utils/caroInactivityUtil';
import { ProcessContext } from '@frontend/components/pages/episodeCategory/carePath/process/processContext';
import { useDefinedContext } from '@frontend/utils/hooks/useDefinedContext';

type BariPreCaroAccountNotActivatedProps = Readonly<{
    untilProcessActivityId?: string;
}>;

export function BariPreCaroAccountNotActivated(props: BariPreCaroAccountNotActivatedProps): JSX.Element {
    const { untilProcessActivityId } = props;
    const { process } = useDefinedContext(ProcessContext);

    return (
        <FormGroup label="Inactiviteit">
            <Row columnGap={2}>
                <Col>
                    <FormParagraph>Niet ingelogd of niet geïnstalleerd</FormParagraph>
                </Col>
                <Col>
                    <Badge {...getBadgeProps()} />
                </Col>
            </Row>
        </FormGroup>
    );

    function getBadgeProps() {
        const untilProcessActivity = process.activities.find((activity) => activity.id === untilProcessActivityId);
        const untilDateTime = untilProcessActivity?.performedDatetime
            ? DateTime.from(untilProcessActivity.performedDatetime)
            : DateTime.now();
        const previousActivities = getPreviousBariPreCaroInactivityPoliReportActivities(
            process.activities,
            untilDateTime
        );

        return getBadge(previousActivities.length + 1);
    }
}
